import * as React from "react";
import IUserUI from "../models/IUserUI";

const UserContext = React.createContext<IUserUI>({} as IUserUI);

export default UserContext;
